/* eslint-disable */
class XmlToJsonParser {
  Data: string | null = null;
  JsonText: string | null = null;
  JsonObject: any = null;

  Parse(data: string): void {
    if (data == null || data.length === 0) {
      const err = '(XmlParser.Init) data is null or has 0 length';
      console.error(err);
      throw new Error(err);
    }
    this.Data = data;

    let xmlDoc!: Document;

    if (window.DOMParser) {
      const parser = new DOMParser();
      xmlDoc = parser.parseFromString(data, 'text/xml');
    }
    // else {
    //     // For IE support (if needed)
    //     const xmlDocIE = new ActiveXObject("Microsoft.XMLDOM") as any;
    //     xmlDocIE.async = false;
    //     xmlDocIE.loadXML(data);
    //     xmlDoc = xmlDocIE;
    // }

    this.JsonText = JSON.stringify(this.xmlToJson(xmlDoc));
    this.JsonObject = JSON.parse(this.JsonText);
  }

  private xmlToJson(xml: Node): any {
    let obj: any = {};

    if (xml.nodeType === 1) {
      // element
      const element = xml as Element;
      if (element.attributes.length > 0) {
        obj['@attributes'] = this.parseAttributes(element);
      }
    } else if (xml.nodeType === 3) {
      // text
      obj = xml.nodeValue;
    }

    if (xml.hasChildNodes()) {
      this.parseChildNodes(xml, obj);
    }

    return obj;
  }
  private parseChildNodes(xml: Node, obj: any): void {
    for (let i = 0; i < xml.childNodes.length; i++) {
      const item = xml.childNodes.item(i);
      if (item) {
        const nodeName = item.nodeName;
  
        if (typeof obj[nodeName] === 'undefined') {
          obj[nodeName] = this.xmlToJson(item);
        } else {
          if (!Array.isArray(obj[nodeName])) {
            obj[nodeName] = [obj[nodeName]]; // Convert to array if multiple nodes with the same name
          }
          obj[nodeName].push(this.xmlToJson(item));
        }
      }
    }
  }
  private parseAttributes(element: Element): { [key: string]: string | null } {
    const attributes: { [key: string]: string | null } = {};
  
    for (let j = 0; j < element.attributes.length; j++) {
      const attribute = element.attributes.item(j);
      if (attribute) {
        attributes[attribute.nodeName] = attribute.nodeValue;
      }
    }
  
    return attributes;
  }
}

export default XmlToJsonParser;
export interface XmlToJsonParserObject {
  Data: string | null;
  JsonText: string | null;
  JsonObject: any;
}
